import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { installClickDelegate, trackEvent } from "@/lib/analytics";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    installClickDelegate();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
    // Defer slightly so document.title (set by pages) is updated first.
    const id = window.setTimeout(() => {
      trackEvent("page_view", {
        category: "navigation",
        page_path: pathname + (search || ""),
        page_title: document.title,
      });
    }, 50);
    return () => window.clearTimeout(id);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
